/* @generated */
import * as React from "react";
import { contentIconRecipe } from "../styles/index.css.esm.js";
import classNames from "classnames";
import { useThemedStyle } from "../hooks/useThemedStyle.esm.js";
import { BackgroundFileSmall } from "./_background/background-file-small.esm.js";
import { useCompositeContentIconViewBox } from "../hooks/useContentIconViewbox.esm.js";
const FilePdfSmall = ({
  className,
  hasWhitespace = true,
  over = "base",
  hasBackground = true,
  ...props
}) => {
  const cls = classNames([
    "dig-ContentIcon",
    className,
    "dig-ContentIcon--small",
    {
      "dig-ContentIcon--overBase": over === "base",
      "dig-ContentIcon--overSubtle": over === "subtle",
      "dig-ContentIcon--hasNoBackground": !hasBackground
    },
    contentIconRecipe({ over, hasNoBackground: !hasBackground })
  ]);
  const style = useThemedStyle({ over });
  const viewBox = useCompositeContentIconViewBox({ hasWhitespace, size: "small" });
  return /* @__PURE__ */ React.createElement(
    "svg",
    {
      viewBox,
      fill: "none",
      role: "presentation",
      focusable: "false",
      width: 40,
      height: 40,
      className: cls,
      "data-testid": "FilePdfSmall",
      style,
      ...props
    },
    hasBackground ? /* @__PURE__ */ React.createElement(BackgroundFileSmall, null) : null,
    /* @__PURE__ */ React.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10.883 10v6H13l.19-.008c1.893-.094 2.813-1.076 2.813-2.992 0-1.95-.954-2.933-2.916-2.997L10.883 10Zm1.15 1v4h.741-.274.378c.868 0 1.27-.202 1.468-.391.196-.19.407-.776.407-1.609s-.21-1.42-.407-1.608c-.197-.19-.6-.392-1.468-.392h-.845Z",
        fill: "#F25123"
      }
    ),
    /* @__PURE__ */ React.createElement("path", { d: "M21.108 11h-2.966v2h2.608v1h-2.608v2h-1.15v-6h4.116v1Z", fill: "#F25123" }),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M5 10v6h1.15v-2l1.893-.006c.527-.03 1.02-.176 1.39-.516.42-.387.567-.919.567-1.478 0-.56-.148-1.09-.568-1.477-.37-.34-.862-.487-1.389-.517L5 10Zm1.15 1v2h1.677c.41 0 .593-.169.679-.248l.004-.004c.084-.078.294-.365.294-.748s-.21-.67-.294-.747l-.004-.004c-.087-.08-.27-.249-.68-.249H6.15Z",
        fill: "#F25123"
      }
    )
  );
};
export {
  FilePdfSmall
};
